import app from '../../app';
import { KeyValueGambit } from '../IGambit';
export default class EmailGambit extends KeyValueGambit {
  key() {
    return app.translator.trans('core.lib.gambits.users.email.key', {}, true);
  }
  hint() {
    return app.translator.trans('core.lib.gambits.users.email.hint', {}, true);
  }
  filterKey() {
    return 'email';
  }
  enabled() {
    return !!(app.session.user && app.forum.attribute('canEditUserCredentials'));
  }
}
flarum.reg.add('core', 'common/query/users/EmailGambit', EmailGambit);